import React from "react";

const BlogSeoPanel = ({
    excerpt,
    setExcerpt,
    metaTitle,
    setMetaTitle,
    metaDescription,
    setMetaDescription,
    ogImage,
    setOgImage,
    canonicalUrl,
    setCanonicalUrl,
    publishedAt,
    setPublishedAt,
    featured,
    setFeatured,
    slug,
    setSlug,
    showSlug = false,
    className = "",
}) => {
    return (
        <div className={`add-blog-seo-panel p-3 border rounded-lg bg-white shadow-sm ${className}`}>
            <h3 className="text-[16px] font-semibold text-black/80 mb-3">SEO & publishing</h3>

            {showSlug && setSlug && (
                <label className="block mb-3">
                    <span className="text-xs font-medium text-gray-600 mb-1 block">URL slug</span>
                    <input
                        type="text"
                        value={slug || ""}
                        onChange={(e) => setSlug(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                        placeholder="my-post-slug"
                    />
                </label>
            )}

            <label className="block mb-3">
                <span className="text-xs font-medium text-gray-600 mb-1 block">Excerpt</span>
                <textarea
                    rows={2}
                    value={excerpt || ""}
                    onChange={(e) => setExcerpt(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                    placeholder="Short summary for listings and search"
                />
            </label>

            <label className="block mb-3">
                <span className="text-xs font-medium text-gray-600 mb-1 block">Meta title</span>
                <input
                    type="text"
                    value={metaTitle || ""}
                    onChange={(e) => setMetaTitle(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                    placeholder="SEO title (optional)"
                />
            </label>

            <label className="block mb-3">
                <span className="text-xs font-medium text-gray-600 mb-1 block">Meta description</span>
                <textarea
                    rows={2}
                    value={metaDescription || ""}
                    onChange={(e) => setMetaDescription(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                    placeholder="155 characters for search snippets"
                />
            </label>

            <label className="block mb-3">
                <span className="text-xs font-medium text-gray-600 mb-1 block">OG image URL</span>
                <input
                    type="text"
                    value={ogImage || ""}
                    onChange={(e) => setOgImage(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                    placeholder="Social share image (optional)"
                />
            </label>

            <label className="block mb-3">
                <span className="text-xs font-medium text-gray-600 mb-1 block">Canonical URL</span>
                <input
                    type="url"
                    value={canonicalUrl || ""}
                    onChange={(e) => setCanonicalUrl(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                    placeholder="https://..."
                />
            </label>

            <label className="block mb-3">
                <span className="text-xs font-medium text-gray-600 mb-1 block">Publish date / schedule</span>
                <input
                    type="datetime-local"
                    value={publishedAt || ""}
                    onChange={(e) => setPublishedAt(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#4e59c2] focus:outline-none"
                />
                <span className="text-[11px] text-gray-500 mt-1 block">
                    Leave empty to publish immediately when status is Live.
                </span>
            </label>

            <label className="flex items-center gap-2 text-sm text-gray-700">
                <input
                    type="checkbox"
                    checked={Boolean(featured)}
                    onChange={(e) => setFeatured(e.target.checked)}
                    className="rounded border-gray-300 text-[#4e59c2] focus:ring-[#4e59c2]"
                />
                Featured post (pin in listings)
            </label>
        </div>
    );
};

export default BlogSeoPanel;
